import { HttpMethod } from "../../components/Common/useFetch";
import { RequestOptions } from "../../components/Common/useRequest";
import useKaEmployeeRequest, { KaEmployeeRequestSpec } from "../../components/Common/useKaEmployeeRequest";

export interface AddBusinessIntegrationDto {
  integrationId: string;
}

const addSpec = (businessId: string): KaEmployeeRequestSpec => ({
  path: `/employeeApi/businesses/${businessId}/integrations`,
  method: HttpMethod.POST,
});

const useAddBusinessIntegration = (businessId: string, options?: RequestOptions<void>) => {
  return useKaEmployeeRequest<AddBusinessIntegrationDto>(addSpec(businessId), options);
}

export default useAddBusinessIntegration;
